import type { ISubjobStage } from '@/interfaces'

export class SubjobStage implements ISubjobStage {
	code: string | null
	name: string | null

	constructor({ code = null, name = null }: Partial<ISubjobStage> = {}) {
		this.code = code
		this.name = name
	}
}
